var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCss3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 80 80",
    width: "80px",
    height: "80px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface152545184"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.549021%,92.54902%,80.784315%)",
      fillOpacity: 1
    },
    d: "M 68.332031 8.332031 L 11.667969 8.332031 L 16.667969 65 L 40 71.667969 L 63.332031 65 Z M 68.332031 8.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(32.549021%,92.54902%,80.784315%)",
      fillOpacity: 1
    },
    d: "M 40 13.332031 L 40 66.5 L 58.667969 61.167969 L 62.832031 13.332031 Z M 40 13.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,9.803922%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 55.167969 21.667969 L 40 21.667969 L 40 28.332031 L 48.167969 28.332031 L 47.667969 35 L 40 35 L 40 41.667969 L 47.332031 41.667969 L 46.832031 49.167969 L 40 51.5 L 40 58.5 L 53.167969 54.167969 L 54.332031 35 Z M 55.167969 21.667969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(3.921569%,9.803922%,18.431373%)",
      fillOpacity: 1
    },
    d: "M 40 21.667969 L 40 28.332031 L 25.167969 28.332031 L 24.667969 21.667969 Z M 32.332031 35 L 32.667969 41.667969 L 40 41.667969 L 40 35 Z M 33 45 L 26.332031 45 L 26.832031 54.167969 L 40 58.5 L 40 51.5 L 33.167969 49.167969 Z M 33 45 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCss3);
export default __webpack_public_path__ + "static/media/css3.3f2396c9d9532349fdfb0028e9bbef15.svg";
export { ForwardRef as ReactComponent };